import { DAYS } from '../../../../constants';
import { getDaysInMonth, getFirstDayOfMonth } from '../../../../utils';

export default function MonthView({ year, month, selectedDate, onSelectDate, isMobile, attendanceData }) {
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);
    const today = new Date();
    const cells = [];

    for (let i = 0; i < firstDay; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);

    const key = (d) => `${year}-${String(month + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

    return (
        <div>
            <div className="month-days-header">
                {DAYS.map((d) => (
                    <div key={d} className="day-header-cell">{d}</div>
                ))}
            </div>
            <div className="month-grid">
                {cells.map((d, i) => {
                    if (!d) return <div key={i} />;
                    const dateKey = key(d);
                    const record = attendanceData?.[dateKey];
                    const status = record?.status;
                    const cellDate = new Date(year, month, d);
                    const isSelected = selectedDate && cellDate.toDateString() === selectedDate.toDateString();

                    return (
                        <div key={i} className="month-day-cell">
                            <button
                                onClick={() => onSelectDate(cellDate)}
                                className={`month-day-btn ${isMobile ? 'mobile' : ''} ${isSelected ? 'selected' : ''}`}
                            >
                                {d}
                                {status && (
                                    <div className={`status-bar status-bar-${status}`} />
                                )}
                            </button>

                        </div>
                    );
                })}
            </div>
        </div>
    );
}
